import { createSystemEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IPermit } from "../../utils/types/models";

export default createSystemEntityReducer<IPermit>(Endpoint.Permits);
